import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { CatalogProvider } from "./facade/catalog";
import Layout from "./facade/Layout";
import Landing from "./facade/Landing";
import Dashboard from "./facade/Dashboard";
import ProjectPage from "./facade/ProjectPage";
import MaterialCatalog from "./facade/MaterialCatalog";
import ProfileLibrary from "./facade/ProfileLibrary";
import BwayPage from "./facade/BwayPage";
import Login from "./facade/Login";
import { useEffect, useState } from "react";
import { fetchMe, setUser } from "./facade/api";

export default function App() {
  const [user, setU] = useState(undefined);
  const signIn = (u) => { setUser(u); setU(u); };
  useEffect(() => { fetchMe().then(signIn); }, []);
  if (user === undefined) return <div className="App dark min-h-screen bg-[#0a0a0b]" data-testid="session-checking" />;
  if (!user) {
    return (
      <div className="App dark">
        <Login onSignedIn={signIn} />
        <Toaster theme="dark" position="top-right" richColors />
      </div>
    );
  }
  return (
    <div className="App dark">
      <CatalogProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route element={<Layout />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/projects/:projectId" element={<ProjectPage />} />
              <Route path="/materials" element={<MaterialCatalog />} />
              <Route path="/profiles" element={<ProfileLibrary />} />
              <Route path="/bway" element={<BwayPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
      </CatalogProvider>
      <Toaster theme="dark" position="top-right" richColors />
    </div>
  );
}
